import moment from 'moment-timezone'

export interface TimeRange {
    start: string
    end: string
}

export function getPreparationTimeBeforeRange(workStart: string | Date, preparationTimeBefore: number): TimeRange {
    return {
        start: moment(workStart).subtract(preparationTimeBefore, 'minutes').format('HH:mm'),
        end: moment(workStart).format('HH:mm')
    }
}

export function getPreparationTimeAfterRange(workEnd: string | Date, preparationTimeAfter: number): TimeRange {
    return {
        start: moment(workEnd).format('HH:mm'),
        end: moment(workEnd).add(preparationTimeAfter, 'minutes').format('HH:mm')
    }
}
